<template>
  <div>
    <PublicLayout>
      <HeaderNav />
      <header class="sub-product-header">
        <div class="container">
          <h1>{{ showProductTitle }}</h1>
        </div>
      </header>

      <!-- 1 核酸飲料 天然DN膠原蛋白 -->
      <article
        id="product1Detail"
        v-if="$route.params.pid == 1"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/drink_2021-thumb-510x510-1577.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Thăng hoa thành vật liệu axit nucleic độc quyền và độc quyền “coreF-Revo.1”
                  <!--昇華為獨家專有之核酸材料 “coreF-Revo.1”-->
                </h2>
                <p>
                  Đây là thức uống tốt cho sức khỏe sử dụng công nghệ độc đáo để chứa axit nucleic hòa tan trong nước (DNA/RNA) và nucleoprotein, là những chất cơ bản của sự sống.
                  <!--此為採用獨特技術，含有稱為生命基本物質的水溶性核酸（DNA/RNA）和核蛋白的保健飲料。-->
                  <br/>
                  Nó kết hợp vật liệu DNA được phát triển độc đáo "FCore-2021" (chiết xuất trắng cá hồi có chứa DNA) và vật liệu RNA mới được phát triển độc lập 
                  "FCore-R2023" (chiết xuất men ăn được có chứa RNA) thành một. (tên: Core-F Revo-One)". Sản phẩm này có chứa collagen peptide, arginine, 
                  chiết xuất tổ ong chứa axit hyaluronic, chiết xuất sụn cá mập có chứa chondroitin, vitamin, khoáng chất và các chất dinh dưỡng khác.
                  <!--與獨家開發的DNA材料「FCore-2021」（含DNA的鮭魚魚白萃取物）和新自主開發的RNA材料「FCore-R2023」（含RNA的食用酵母萃取物）合而為一，誔生了核酸材料「coreF-Revo . 1（名稱：Core-F Revo-One）」。此含有膠原蛋白勝肽、精胺酸、含透明質酸的雞冠萃取物、含軟骨素的鯊魚軟骨萃取物、維生素、礦物質等多種營養素。-->
                  <br/>
                  Hãy coi nó như một thực phẩm bổ sung dinh dưỡng với vị ngọt nhẹ và sảng khoái để duy trì sức khỏe hàng ngày của bạn.
                  <!--請作為營養補助品攝取，具有溫和的甜味和清爽的味道，以維持您的日常健康。-->
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">Tên sản phẩm<!--產品名稱--></th>
                    <td class="font-weight-bold">Fudizhi DN Collagen (Nước uống giải khát)<!--富地滋DN膠原(清涼飲料水)--></td>
                  </tr>
                  <tr>
                    <th>Giá thành viên (giá bán thống nhất)<!--會員價格(統一售價)--></th>
                    <td>NT. 3,600 nhân dân tệ/chai<!--NT. 3,600元/瓶--></td>
                  </tr>
                  <tr>
                    <th>Khối lượng nội dung<!--內容量--></th>
                    <td>720ml</td>
                  </tr>
                  <tr>
                    <th>Lưu phương pháp<!--保存方法--></th>
                    <td>
                      Hãy bảo quản ở nơi khô ráo, thoáng mát, tránh ánh nắng trực tiếp. Sau khi mở chai, hãy bảo quản trong tủ lạnh và uống càng sớm càng tốt.
                      <!--請存放於陰涼乾燥通風處，避免陽光直射。開瓶後請置於冰箱冷藏保存，並盡早飲用完畢。-->
                    </td>
                  </tr>
                  <tr>
                    <th>成分內容物</th>
                    <td>
                      Collagen peptide (lợn), chất làm ngọt (erythritol), đường, chiết xuất hạt cá hồi, xi-rô đường hiếm (glucose, fructose, D-psicose), 
                      chiết xuất men (Candida utilis), men ăn được (men kẽm), chiết xuất sụn cá mập, chiết xuất tổ ong, axit citric, 
                      axit ascorbic (vitamin C), L-arginine, magie cacbonat, chất bảo quản (natri benzoat), nicotinamide, hương thơm, màu caramel, 
                      canxi benzoat, chất làm ngọt (sucralose), hợp chất nhũ hóa (ester sorbitan axit béo, đậu nành, lecithin, lactose), 
                      pyridoxine hydrochloride (vitamin B6), riboflavin (vitamin B2), thiamine nitrat (vitamin B1), axit folic, cyanocobalamin (vitamin B12)
                      <!--膠原胜肽(豬)、甜味劑(赤藻糖醇)、砂糖、鮭魚精巢提取物、含稀少糖糖漿(葡萄糖、果糖、D-阿洛酮糖)、酵母提取物〔酵母菌
                      (Candida utilis)〕、食用酵母(鋅酵母)、鯊魚軟骨提取物、雞冠提取物、檸檬酸、抗壞血酸(維生素C)、L-精胺酸、碳酸鎂、防腐劑(苯甲酸鈉)、菸鹼醯胺、香料、焦糖色素、本多酸鈣、甜味劑(蔗糖素)、複合乳化劑(脂肪酸山梨醇酐酯、大豆卵磷脂、乳糖)、鹽酸吡哆辛(維生素B6)、核黃素(維生素B2)、硝酸硫胺明(維生素B1)、葉酸、氰鈷胺明(維生素B12)-->
                    </td>
                  </tr>
                  <tr>
                    <th>Nhãn dinh dưỡng (trên 100ml)<!--營養標示(每100ml)--></th>
                    <td>
                      Calo: 99,6 calo, protein: 13,9 gam, chất béo: 0 gam, carbohydrate: 11 gam, đường: 4,3 gam, natri: 40,5 mg
                      <!--熱量：99.6大卡、蛋白質：13.9公克、脂肪：0公克、碳水化合物：11公克、糖：4.3公克、鈉：40.5毫克-->
                    </td>
                  </tr>
                  <tr>
                    <th>Cách uống<!--飲用方式--></th>
                    <td>
                      Hãy lắc đều trước khi uống. Uống một lượng thích hợp mỗi ngày, cả vào buổi sáng và buổi tối. Bạn có thể pha loãng với nước tùy theo sở thích cá nhân.
                      <!--飲用前請先輕搖均勻，每日適量飲用，早晚皆適宜。可依個人喜好口感搭配加水稀釋飲用。-->
                    </td>
                  </tr>
                  <tr>
                    <th>Ghi nhãn chất gây dị ứng<!--過敏原標示--></th>
                    <td>Sản phẩm này có chứa sữa và các sản phẩm từ sữa, cá và các sản phẩm từ sữa, đậu nành<!--本產品含有牛奶及其製品、魚類及其製品、大豆--></td>
                  </tr>
                </table>
                <div>
                  <p style="font-size: 14px">
                    ※Sản phẩm này không phải là thuốc và không dùng để điều trị bệnh, nhưng nó có ý nghĩa tích cực trong việc duy trì hàng ngày. Một chế độ ăn uống cân bằng là điều cần thiết để duy trì sức khỏe tốt.
                    <!--※本產品不是藥物，不是用於疾病的治療，但對於日常保養有積極的意義。均衡飲食是維持健康的要素。-->
                  </p>
                  <p style="font-size: 14px">
                    ※Hãy tuân thủ các quy định quản lý an toàn thực phẩm và không phóng đại hoặc tuyên bố sai sự thật về hiệu quả để tránh vi phạm pháp luật!
                    <!--※請遵守食品安全管理辦法，切勿誇大不實或宣稱療效，以免觸法！-->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <section class="m-sec">
          <div class="container">
            <h2 class="section-title">飲用方法</h2>
            <p>
              建議一天飲用量為30~60ml，直接冷藏後飲用或是添加冰水或喜歡的冷飲飲用皆可。
              如果有出現浮游物或沉澱的情形，並不是變質，請先輕搖後再飲用。
              開瓶後請冷藏，並盡早飲用。
            </p>
          </div>
        </section> -->
      </article>
      <!-- 1 核酸飲料 天然DN膠原蛋白 end -->
      <!-- 2 富地滋樂活隨身包 -->
      <article
        id="product2Detail"
        v-if="$route.params.pid == 2"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/BCAA_newpkg-thumb-510x510-1421_04.png"
                  class="product-detail-main-img w-100"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">axit amin quan trọng ‧ Duy trì sức mạnh cơ bắp khỏe mạnh và tốt<!--關鍵胺基酸 ‧ 維持健康好肌力--></h2>
                <p>Nâng cấp và phát triển! Số lượng axit amin bổ sung đã tăng từ 4 lên 12 ban đầu.<!--升級再進化！添加的胺基酸種類由原來的4種增加到12種。--></p>
                <p>
                  Để tổng hợp protein cơ hiệu quả hơn, "tất cả 9 thành phần toàn diện axit amin thiết yếu" được phát triển thông qua nghiên cứu và phát triển đều được bổ sung, 
                  cũng như "axit DL-aminopropionic" có tác dụng tương tự như glutamine. Sự bổ sung đầy đủ và cân bằng các axit amin, nguyên liệu thô để xây dựng cơ bắp, 
                  cải thiện hiệu quả tập luyện và xây dựng một cơ thể khỏe mạnh.
                  <!--為了更有效地合成肌肉蛋白，添加了研究開發的「全9種必需胺基酸綜合成分」，以及與麩醯胺酸具有相同作用的「DL-胺基丙酸」。完整均衡添加製造肌肉的原料-胺基酸，提升運動效率，打造強勁體魄。-->
                </p>
                <p>
                  Thiết kế bao bì dạng dải dài dễ dàng mang theo và có thể dễ dàng ăn khi đi ra ngoài. Hương vị ngọt ngào và sảng khoái làm tăng thêm vị ngon.
                  <!--攜帶方便的長條形包裝設計，外出時也能輕鬆食用。清甜爽口的風味更添一番美味。-->
                </p>
              </div>
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">Tên sản phẩm<!--產品名稱--></th>
                    <td class="font-weight-bold">Túi xách tay Fortune Zi LOHAS<!--富地滋樂活隨身包--></td>
                  </tr>
                  <tr>
                    <th>Giá thành viên (giá bán thống nhất)<!--會員價格(統一售價)--></th>
                    <td>NT. 2,250 nhân dân tệ/chai<!--NT. 2,250元/瓶--></td>
                  </tr>
                  <tr>
                    <th>Khối lượng nội dung<!--內容量--></th>
                    <td>105 gam (3,5g×30 túi)<!--105公克(3.5g×30包)--></td>
                  </tr>
                  <tr>
                    <th>Lưu phương pháp<!--保存方法--></th>
                    <td>Hãy đặt nó ở nơi mát mẻ, khô ráo và thoáng mát, tránh ánh nắng trực tiếp.<!--請放置於陰涼乾燥通風處，避免陽光直射。--></td>
                  </tr>
                  <tr>
                    <th>Nội dung thành phần<!--成分內容物--></th>
                    <td>
                      Chất làm ngọt (maltitol), Elastin (cá), L-leucine, axit DL-aminopropionic, axit L-α aminoisovaleric, L-isoleucine, axit xitric, glutamine, Glycine, 
                      axit L-diaminocaproic, hương vị, canxi photphat, chất làm ngọt (aspartame, thaumatin, steviol glycoside, acesultone kali), axit L-hydroxybutyric, 
                      trứng đậu nành Phospholipids, L-phenylalanine, pullulan gum, L-methionine, L-histidine, axit nicotinic, L-tryptophan, pyridoxine hydrochloride (vitamin B6)
                      <!--甜味劑(麥芽糖醇)、彈性蛋白(魚)、L-白胺酸、DL-胺基丙酸、L-α胺基異戊酸、L-異白胺酸、檸檬酸、麩醯胺酸、胺基乙酸、L-二胺基己酸、香料、磷酸鈣、甜味劑(阿斯巴甜、索馬甜、甜菊醣苷、醋磺內酯鉀)、L-羥丁胺酸、大豆卵磷脂、L-苯丙胺酸、普魯蘭膠、L-蛋胺酸、L-組胺酸、菸鹼醯胺、L-色胺酸、鹽酸吡哆辛(維生素B6)-->
                    </td>
                  </tr>
                  <tr>
                    <th>Thông tin dinh dưỡng (3,5 gram mỗi khẩu phần)<!--營養標示(每份3.5公克)--></th>
                    <td>
                      Calo: 13,9 calo, protein: 2,1 gam, chất béo: 0 gam, carbohydrate: 1,3 gam, đường: 0 gam, natri: 0,3 mg
                      <!--熱量：13.9大卡、蛋白質：2.1公克、脂肪：0公克、碳水化合物：1.3公克、糖：0公克、鈉：0.3毫克-->
                    </td>
                  </tr>
                  <tr>
                    <th>Cách uống<!--飲用方式--></th>
                    <td>
                      Nên dùng 1 ~ 2 gói mỗi ngày. Có thể pha với nước uống theo sở thích cá nhân, hoặc có thể hòa tan trong nước rồi uống, hoặc kết hợp với Nước uống 
                      Collagen Fortune DN.
                      <!--建議一天1~2包。可依照個人口感，搭配飲用水，亦可溶於水中飲用或搭配富地滋DN膠原飲品。-->
                      <br />
                      Hãy uống xong càng sớm càng tốt sau khi mở. (※Nên dùng trước và sau khi tập thể dục)
                      <!--開封後請盡快飲用完畢。(※建議運動前、運動後食用)-->
                    </td>
                  </tr>
                  <tr>
                    <th>Những điều cần lưu ý<!--注意事項--></th>
                    <td>Sản phẩm này có chứa chất làm ngọt (aspartame) và những người mắc bệnh phenylketon niệu không nên sử dụng.<!--本產品含甜味劑（阿斯巴甜），苯酮尿症者不宜食用。--></td>
                  </tr>
                  <tr>
                    <th>Ghi nhãn chất gây dị ứng<!--過敏原標示--></th>
                    <td>Sản phẩm này có chứa cá và các sản phẩm từ cá, đậu nành<!--本產品含有魚類及其製品、大豆--></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </article>
      <!-- 2 富地滋樂活隨身包 end -->
      <!-- 3 新‧夢莎ED膠原蛋白飲 -->
      <article
        id="product3Detail"
        v-if="$route.params.pid == 3"
        class="main-section">
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/IMG_058-thumb-510x363-1106.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  鳳梨由來的賽洛美及搭配膠原蛋白的美容飲
                </h2>
                <p>
                  加入鳳梨由來的賽洛美、採用富地滋獨家膠原蛋白以及搭配原本「多肽型膠原蛋白」的三倍。維他命C也增量了10%，是一瓶多方面實現美的培育力、且均衡配合維他命及礦物質的飲品。幫助我們每日健康又美麗。
                  這款膠原蛋白飲推薦給對於想提高每天水潤潤實感的人們、追求透明感、清澈的美的人們以及想要
                  每天Q彈緊緻、朝氣蓬勃生活的人們。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">飲用方法</h2>
            <p>建議飲用量1天1瓶，冷藏並輕搖後再飲用。 開封後請盡速飲用完畢。</p>
          </div>
        </section>
      </article>
      <!-- 3 新‧夢莎ED膠原蛋白飲 end -->
      <!-- 4 LU tia 高機能美容精華液 -->
      <article
        id="product4Detail"
        v-if="$route.params.pid == 4"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/LU_tia高機能美容精華液.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Tinh chất làm đẹp sáng tạo và tái phát triển
                  <!--革新再進化的美容精華液 -->
                  <br />
                  Chăm sóc chống lão hóa chăm sóc da cẩn thận mang lại cho làn da cảm giác chưa từng có trước đây.
                  <!--細緻呵護肌膚的抗老化保養，賦予肌膚從未體驗過的感受。-->
                </h2>
                <p>
                  Nó kết hợp các chức năng của kem dưỡng da, kem dưỡng da, tinh chất và kem tinh chất vào một chai và có thể phát huy nhiều tác dụng chăm sóc da chỉ trong một bước.
                  <!--集結化妝水、乳液、精華液、精華霜的功能於一瓶，只要一個步驟就能發揮多重肌膚保養功效。-->
                </p>
                <p>
                  4 loại thành phần axit nucleic mới được bổ sung theo đuổi chức năng (chứa ATP) và "Trojan Q10" và "Chiết xuất tế bào gốc thực vật" 
                  đưa việc chăm sóc da chống lão hóa lên một tầm cao mới. Mang lại cho làn da sự săn chắc, đàn hồi, mịn màng, mềm mại và mềm mại, 
                  đồng thời làm mờ các nếp nhăn khô.
                  <!--新添加追求機能性(含有ATP)的4種核酸成分及「Trojan Q10」、「植物性幹細胞萃取成分」，引領抗老化保養進入全新境界。賦予肌膚緊實有彈性、細緻柔滑水嫩感，撫平乾燥小細紋。-->
                </p>
              </div>
            </div>

           <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">Tập trung vào “ty thể”, nhà máy điện bên trong tế bào<!--著眼細胞內的發電廠「粒線體」--></div>
                <p>
                  Ty thể là các bào quan được tìm thấy trong tế bào và cung cấp năng lượng cần thiết cho tế bào. Khi tuổi tác tăng lên, hoạt động của ty 
                  thể giảm dần và các tế bào không thể có đủ năng lượng, khiến quá trình lão hóa diễn ra nhanh hơn. Vì vậy, tăng cường năng lượng chuyển 
                  hóa tế bào chính là chìa khóa để có làn da đẹp.
                  <!--粒線體存在於細胞內的胞器，提供細胞所需的能量。隨著年齡增長，粒線體活性慢慢衰退，細胞無法獲得足夠能量，使人加速老化。因此提升細胞新陳代謝的能量則是決定美肌的關鍵。-->
                </p>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    Trojan Q10
                  </h3>
                  <p>
                    Coenzym Q10, một chất chống oxy hóa nổi tiếng, được cấu tạo từ "Trojan Q10" với công nghệ phủ đặc biệt, có thể khóa trực tiếp vào nguyên bào sợi để cung cấp năng lượng và tiếp thêm sinh lực mới.
                    <!--抗氧化著稱的輔酶Q10，以特殊包覆技術後而成的「Trojan Q10」可直接鎖定纖維母細胞，提供能量，注入新活力。-->
                  </p>
                </div>
                <div>
                  <h3 class="subtitle-pink">Thành phần chiết xuất tế bào gốc thực vật<!--植物性幹細胞萃取成分--></h3>
                  <p>
                    Được lấy từ tế bào gốc mầm ô liu hoang dã, nó giúp duy trì năng lượng da bị suy giảm do tuổi tác ở tình trạng tốt nhất và lý tưởng.
                    <!--來自野生橄欖新芽幹細胞萃取，有助於因年齡增長而下降的肌膚能量維持在最佳理想狀態。-->
                  </p>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">Tập trung vào tình trạng căng thẳng của da<!--著眼於肌膚的壓力--></div>
                <p>
                  Thành phần mới được bổ sung "Regenesea" tập trung vào sức sống của rong biển phát triển trong môi trường khắc nghiệt và thành phần "Chiết xuất Artemia" giúp bảo vệ da khỏi các tác động khác nhau của môi trường được thêm vào.
                  <!--新添加著眼於在嚴峻環境下生長的海藻生命力成分「褐藻萃取物(Regenesea)」，以及添加保護肌膚免受各種環境影響的「鹵蟲萃取物」成分。-->
                </p>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    Chiết xuất tảo nâu<!--褐藻萃取物-->／Regenesea (SACCHARINA LONGICRURIS EXTRACT)
                  </h3>
                  <p>
                    Được lấy từ dòng sông băng lạnh giá Bắc Đại Tây Dương, rong biển có sức sống mãnh liệt.
                    <!--萃取自嚴寒北大西洋冰河中，具有強悍生命力的海藻。-->
                  </p>
                </div>
                <div>
                  <h3 class="subtitle-pink">Chiết xuất Artemia<!--鹵蟲萃取物--> / Artemia Extract</h3>
                  <p>
                    Nó được lấy từ trứng bền của sinh vật phù du biển có tên Artemia (tên khoa học: Artemia) sống ở các hồ nước mặn có nồng độ cao như hồ muối và Biển Chết.
                    <!--萃取自棲息於鹽湖或死海等高濃度鹽水湖中，被稱為鹵蟲(學名：Artemia)的海洋浮游生物的耐久卵中。-->
                  </p>
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">LU tia Tinh chất làm đẹp có chức năng cao, chức năng cơ bản<!--LU tia 高機能美容精華液 基本機能性--></div>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    Hydrat hóa lâu dài cho da - bơm độ ẩm hiệu quả vào đáy da để đạt được cảm giác ngậm nước cả bên trong lẫn bên ngoài
                    <!--肌膚持久水潤 – 強效注入肌底水份・達到內外水感-->
                  </h3>
                  <ul>
                    <li>
                      Chứa 4 loại thành phần axit nucleic nồng độ cao, cộng với "axit folic" là thành phần axit nucleic phụ trợ, cũng như 
                      "Chiết xuất Samara" và "ACETYL HEXAPEPTIDE-51 AMIDE" để giữ ẩm và giữ ẩm cho da trong thời gian dài.
                      <!--添加4種高濃度核酸成分，
                      再加入輔助核酸成分的「葉酸」，以及『翅果鐵刀木萃取物』
                      與『ACETYL HEXAPEPTIDE-51 AMIDE』，使肌膚持久滋潤，充滿水潤感。-->
                    </li>
                    <li>
                      Đã thêm "NMF (Yếu tố giữ ẩm tự nhiên)" là chìa khóa để giữ ẩm ở lớp sừng và "phức hợp axit amin" giúp cân bằng axit amin, có thể phục hồi quá trình hydrat hóa từ trong ra ngoài.
                      <!--添加角質層中保濕關鍵之『NMF(天然保濕因子)』胺基酸平衡的『胺基酸複合物』，由裡到外重現飽水潤澤。-->
                    </li>
                    <li>
                      Nó cũng được kết hợp với thành phần dưỡng ẩm độc quyền của FORDAYS "Kasparin (hexapeptide-42 peptide/polypeptide)" 
                      và thành phần dưỡng ẩm theo thời gian "Biosacarit Gum-1", có tác dụng dưỡng ẩm lâu dài và tăng cường độ mềm mại, trong suốt của da. làn da.
                      <!--亦配合FORDAYS獨家保濕成分『Kasparin(hexapeptide-42胜肽/多肽類)』及時間差保濕成分「生物糖膠-1」，
                      具有長效保濕作用，提升肌膚柔和透明感。-->
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-pink">
                    Công nghệ nhũ hóa đặc biệt hòa quyện vào da và cung cấp độ ẩm hoàn chỉnh
                    <!--融入肌膚、完整保濕的特殊乳化技術-->
                  </h3>
                  <p>
                    Tinh chất làm đẹp này với kết cấu kem đặc, thẩm thấu ngay lập tức khi thoa lên da và nhanh chóng thẩm thấu vào lớp sừng của da. Và thông qua 
                    "công nghệ nhũ hóa vi mô", kết cấu da được tinh chế và thẩm thấu vào lớp sừng của da như một cảm giác xuyên thấu, 
                    và bạn có thể cảm nhận được ba kết cấu của kem dưỡng ẩm, mịn màng như kem dưỡng da và cảm giác dưỡng ẩm của kem cùng một lúc.
                    <!--濃厚乳霜質地的美容精華液，塗抹在肌膚上瞬間被吸收，迅速滲透至肌膚角質層。並且透過「微乳化技術」,使肌膚質地細緻，像滲透感般被吸附進肌膚角質層內，同時感受化妝水的水嫩・乳液般的柔滑・乳霜的保濕感這三種觸感。-->
                  </p>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">Tên sản phẩm<!--產品名稱--></th>
                    <td class="font-weight-bold">LU tia Tinh chất làm đẹp hiệu suất cao<!--LU tia 高機能美容精華液--></td>
                  </tr>
                  <tr>
                    <th>Giá thành viên (giá bán thống nhất)<!--會員價格(統一售價)--></th>
                    <td>NT. 4,000 nhân dân tệ/chai<!--NT. 4,000元/瓶--></td>
                  </tr>
                  <tr>
                    <th>Khối lượng nội dung<!--內容量--></th>
                    <td>50 gram<!--50公克--></td>
                  </tr>
                  <tr>
                    <th>Cách sử dụng<!--使用方式--></th>
                    <td class="font-weight-bold">
                      Sau khi rửa mặt, lấy một lượng thích hợp vào lòng bàn tay và thoa đều lên toàn bộ khuôn mặt. Nó kết hợp các chức năng của toner, serum làm đẹp, kem dưỡng da và kem trong một chai.
                      <!--洗臉後，取適量於掌心，均勻塗抹於全臉。集結化妝水、美容液、乳液、乳霜功效於一瓶。-->
                      <br />
                      Chăm sóc da chỉ cần một bước là xong.
                      <!--肌膚保養只要一個步驟便大功告成。-->
                    </td>
                  </tr>
                  <tr>
                    <th>Cách sử dụng nâng cao<!--進階使用方法--></th>
                    <td class="font-weight-bold">
                      Theo mục đích bảo trì, vui lòng hợp tác với Dòng sản phẩm chăm sóc da hiệu ứng kép của Mengsha Reverse Time Double Effect II.
                      <!--請依據保養目的，配合夢莎逆時雙效保養品系列Ⅱ。-->
                    </td>
                  </tr>
                  <tr>
                    <th>Chăm sóc dịu dàng<!--溫柔呵護--></th>
                    <td>
                      <ul type="circle">
                        <li>Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc nước hoa.<!--不使用酒精、礦物油、色素、香料。--></li>
                        <li>
                          Kiểm tra da và kiểm tra dị ứng đã được thực hiện. (Tất cả những người thử nghiệm đều vượt qua bài kiểm tra. Tuy nhiên, điều này không có nghĩa là mọi người sẽ không bị nhạy cảm hoặc kích ứng da.)
                          <!--已進行過貼膚測試・過敏測試。(所有測試者皆通過測試。但並非表示所有人都不會有肌膚敏感或刺激的情形發生。)-->
                        </li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </article>
      <!-- 4 LU tia 高機能美容精華液 end -->
      <!-- 5 夢莎逆時雙效潔面乳Ⅱ -->
      <article
        id="product5Detail"
        v-if="$route.params.pid == 5"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效潔面乳Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Tẩy trang với cảm giác ấm áp
                  <!--擁有微溫感的卸妝感受-->
                  <br />
                  Làm sạch và tẩy trang + massage ấm
                  <!--潔面卸妝+溫感按摩-->
                </h2>
                <p>
                  Nó tạo cảm giác hơi ấm khi thoa lên da. Trong khi tẩy trang còn có tác dụng massage, có thể nhanh chóng hòa tan lớp trang điểm và rửa sạch thật sạch. Chứa các thành phần dưỡng ẩm mang lại cảm giác ngậm nước cho da.
                  <!--在肌膚上延展後會產生微溫感。卸妝的同時也能擁有按摩的效果，能快速溶解妝容，徹底洗淨。含有保濕成分賦予肌膚水潤感。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>110g</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12">
                <div>
                  <h3 class="subtitle-black">Loại bỏ hoàn toàn bụi bẩn<!--徹底去除髒污--></h3>
                  <ul>
                    <li>
                      Nhanh chóng hòa tan lớp trang điểm mà không để lại cặn, mang lại cho bạn cảm giác sạch sẽ sau khi rửa.
                      <!--快速溶解妝容不殘留，讓人感受到洗後的潔淨感。-->
                    </li>
                    <li>
                      Chiết xuất hạt xà phòng, có chứa các thành phần phụ trợ làm sạch, không chỉ bảo vệ da mà còn rửa sạch lớp trang điểm còn sót lại mịn màng, mang lại hiệu quả làm sạch kỹ lưỡng.
                      <!--具有洗淨輔助成分的無患子種子萃取物，守護肌膚的同時，也洗去細微的殘妝，發揮徹底洗淨的功效。-->
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">nhiệt độ dễ chịu<!--讓人感到愉快的溫度--></h3>
                  <ul>
                    <li>
                      Bạn sẽ cảm thấy hơi ấm nhẹ khi tiếp xúc với da. Trong khi tẩy trang, bạn còn có thể tận hưởng tác dụng massage ấm, mang lại cho người dùng cảm giác thoải mái hơn.
                      <!--接觸到肌膚後感受到微溫感。卸妝的同時也享受到溫感按摩的效果，帶給使用者更舒適的觸感。-->
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">Da vẫn được giữ ẩm sau khi rửa<!--洗後肌膚保持潤澤--></h3>
                  <ul>
                    <li>
                      4 loại thành phần axit nucleic giúp da ẩm, đàn hồi và ngậm nước hơn.
                      <!--4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。-->
                    </li>
                    <li>
                      Thành phần độc quyền "Kasparin" của FORDAYS được bổ sung, cũng như các thành phần bảo vệ da như chiết xuất lá samara, axit hyaluronic Na và các thành phần dưỡng ẩm khác. Hiệu quả dưỡng ẩm của da vẫn được duy trì sau khi rửa.
                      <!--添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。-->
                    </li>
                    <li>
                      Thành phần dưỡng ẩm Lipidure (polyqu Parentium-51) ngăn ngừa độ ẩm của da bốc hơi và bảo vệ da.
                      <!--保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。-->
                    </li>
                    <li>
                      Thành phần Glycyrrhizic acid 2K bảo vệ da và góp phần tăng cường sức khỏe làn da.
                      <!--甘草酸 2K成分，保護肌膚，也有助於肌膚的健康。-->
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">Một mùi thơm dễ chịu<!--讓人心情愉悅的香氣--></h3>
                  <ul>
                    <li>
                      Hương hoa cam quýt sảng khoái từ tinh dầu, hương thơm tinh tế giúp người dùng thư giãn hơn.
                      <!--來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。-->
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">Nhẹ nhàng hơn trên da<!--對肌膚更溫柔的用心--></h3>
                  <ul>
                    <li>
                      Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc hương thơm.
                      <!--不使用酒精、礦物油、色素和香料。-->
                    </li>
                  </ul>
                </div>
                <div class="product-using-hint">
                  <h3 class="mt-0">Cách sử dụng<!--使用方法--></h3>
                  <p>
                    Vui lòng sử dụng khi da khô. Lấy một lượng thích hợp vào lòng bàn tay, trải đều ra lòng bàn tay và thoa cẩn thận và nhẹ nhàng lên da. Sau khi lớp trang điểm tan đi, hãy rửa sạch thật sạch bằng nhiều nước ấm.
                    <!--請在肌膚處於乾燥時使用。取用適量於掌心，在掌心推展開後，仔細地輕輕塗抹於肌膚上。彩妝溶解後，使用大量溫水充分洗淨。-->
                  </p>
                  <p class="text-small">※ Sẽ có cảm giác hơi ấm khi tiếp xúc với da.<!--※接觸到肌膚後會感受到微溫。--></p>
                  <p class="text-small">
                    ※Khi tẩy trang vùng mắt, nên sử dụng sản phẩm tẩy trang chuyên dụng.
                    <!--※卸除眼妝時，建議使用專用的卸妝產品。-->
                  </p>
                  <p class="text-small mb-0">
                    ※Tiếp xúc với mắt có thể gây đau và khó chịu, vì vậy hãy cẩn thận.
                    <!--※接觸到眼睛可能會引起疼痛不適，請務必留意。-->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
      <!-- 5 夢莎逆時雙效潔面乳Ⅱ end -->
      <!-- 6 夢莎逆時雙效洗顏霜Ⅱ -->
      <article
        id="product6Detail"
        v-if="$route.params.pid == 6"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效洗顏霜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Các bong bóng dày đặc và mịn thực sự làm sạch mọi ngóc ngách của da
                  <!--綿密細緻的泡泡確實潔淨肌膚的每個角落-->
                   <br />
                  Làm sạch da mặt + làm sạch và tẩy trang<!--洗顏+潔顏卸妝-->
                </h2>
                <p>
                  Dạng kem, bọt dày đặc và mịn có thể làm sạch da hiệu quả. Chứa thành phần tẩy trang có thể tẩy sạch kem chống nắng hoặc BB cream. Chứa các thành phần dưỡng ẩm mang lại cảm giác ngậm nước cho da.
                  <!--奶油般綿密細緻的泡泡能確實潔淨肌膚。含有卸妝成分，能卸除防曬乳或BB霜。含有保濕成分賦予肌膚水潤感。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>100g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">Làm sạch hoàn toàn bụi bẩn<!--徹底潔淨髒污--></p>
            <ul>
              <li>
                Các bong bóng dạng kem, đậm đặc và tinh tế bám chặt vào da và làm sạch triệt để mọi ngóc ngách.
                <!--奶油般豐盈細緻的泡泡，能緊密貼合肌膚，徹底洗淨每個角落。-->
              </li>
              <li>
                Chứa chiết xuất hạt xà phòng, một thành phần phụ trợ làm sạch, giúp bảo vệ da đồng thời rửa sạch bụi bẩn.
                <!--含有洗淨輔助成分無患子種子萃取物，守護肌膚的同時也能洗淨髒污。-->
              </li>
              <li>
                Nó có thể dễ dàng rửa sạch bong bóng, mang lại cho bạn cảm giác sảng khoái mà không để lại bất kỳ dư lượng nào.
                <!--能輕鬆洗淨泡泡，帶來清爽不殘留的感受。-->
              </li>
            </ul>
            <p class="font-weight-bold">Loại bỏ kem chống nắng hoặc trang điểm nhẹ<!--卸除防曬乳或淡妝--></p>
            <ul>
              <li>
                Với thành phần tẩy trang có thể tẩy sạch các lớp trang điểm nhẹ như kem chống nắng hay BB cream.
                <!--配合卸妝成分，能卸除防曬乳或BB霜等淡妝。-->
              </li>
            </ul>
            <p class="font-weight-bold">Da vẫn được giữ ẩm sau khi rửa<!--洗後肌膚保持潤澤--></p>
            <ul>
              <li>
                4 loại thành phần axit nucleic giúp da ẩm, đàn hồi và ngậm nước hơn.
                <!--4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。-->
              </li>
              <li>
                Thành phần độc quyền "Kasparin" của FORDAYS được bổ sung, cũng như các thành phần bảo vệ da như chiết xuất lá samara, 
                axit hyaluronic Na và các thành phần dưỡng ẩm khác. Hiệu quả dưỡng ẩm của da vẫn được duy trì sau khi rửa.
                <!--添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。-->
              </li>
              <li>
                Thành phần dưỡng ẩm Lipidure (polyqu Parentium-51) ngăn ngừa độ ẩm của da bốc hơi và bảo vệ da.
                <!--保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。-->
              </li>
              <li>
                Thành phần stearyl glycyrrhizinate bảo vệ da và góp phần tăng cường sức khỏe cho làn da.
                <!--甘草酸硬脂酯的成分守護肌膚，有助於肌膚的健康。-->
              </li>
            </ul>
            <p class="font-weight-bold">Một mùi thơm dễ chịu<!--讓人心情愉悅的香氣--></p>
            <ul>
              <li>
                Hương hoa cam quýt sảng khoái từ tinh dầu, hương thơm tinh tế giúp người dùng thư giãn hơn.
                <!--來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。-->
              </li>
            </ul>
            <p class="font-weight-bold">Nhẹ nhàng hơn trên da<!--對肌膚更溫柔的用心--></p>
            <ul>
              <li>
                Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc hương thơm.
                <!--不使用酒精、礦物油、色素和香料。-->
              </li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">Cách sử dụng<!--使用方法--></h3>
              <p class="mb-0">
                Lấy một lượng thích hợp vào lòng bàn tay, tạo bọt, rửa mặt rồi rửa sạch bọt bằng nước ấm.
                <!--取適量在掌心，搓揉起泡後洗臉，再用溫水洗去泡泡。 -->
                <br />
                Nếu sử dụng lưới tạo bọt, bạn có thể dễ dàng tạo bọt chi tiết và đầy đặn hơn.
                <!--如果使用起泡網，更能輕易做出更細緻豐盈的泡沫。-->
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 6 夢莎逆時雙效洗顏霜Ⅱ end -->
      <!-- 7 夢莎逆時雙效洗顏皂Ⅱ -->
      <article
        id="product7Detail"
        v-if="$route.params.pid == 7"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效洗顏皂Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Bong bóng dày và đầy đặn làm sạch da triệt để
                  <!--綿密豐盈的泡泡徹底洗淨肌膚 -->
                  <br />
                  Làm sạch + Mặt nạ bong bóng
                  <!--洗顏+泡泡面膜-->
                </h2>
                <p>
                  Nó rất dễ tạo bọt và có chất lượng bong bóng dày đặc và mịn. Nó làm sạch da triệt để thông qua các bong bóng mềm và đầy đặn. 
                  Chứa các thành phần dưỡng ẩm mang lại cảm giác ngậm nước cho da. Nó cũng có thể được sử dụng như mặt nạ bong bóng để hấp thụ bụi bẩn sâu từ lỗ chân lông.
                  <!--秉持容易起泡，又擁有綿密細緻的泡泡質量，透過柔軟豐盈的泡泡徹底洗淨肌膚。含有保濕成分賦予肌膚水潤感。也可用來當泡泡面膜將毛孔內深層髒污吸附出來。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>Trọng lượng tiêu chuẩn 100g<!--標準重量100g--></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">Rửa sạch bụi bẩn<!--徹底洗淨髒污--></p>
            <ul>
              <li>
                Tuân thủ chất lượng của các bong bóng phong phú, dày đặc, tinh tế và lâu dài, nó làm sạch triệt để mọi ngóc ngách của da thông 
                qua các bong bóng mềm mại và đầy đặn.
                <!--秉持泡泡多且綿密細緻持久的質量，透過柔軟豐盈的泡泡，徹底洗淨肌膚每個角落。-->
              </li>
              <li>
                Cũng có thể được sử dụng như mặt nạ bong bóng. Các bong bóng mềm và đàn hồi có thể hấp thụ và làm sạch lỗ chân lông.
                <!--也可作為泡泡面膜使用。柔軟又有彈性的泡泡，能夠吸附毛孔髒污清潔乾淨。-->
              </li>
              <li>
                Chứa đất tự nhiên có khả năng hút bụi bẩn và làm sạch lỗ chân lông.
                <!--含有天然泥土能吸附毛孔髒污清潔乾淨。-->
              </li>
              <li>
                Thêm thành phần phụ trợ làm sạch chiết xuất hạt xà phòng để bảo vệ da đồng thời rửa sạch bụi bẩn.
                <!--添加洗淨輔助成分無患子種子萃取物，保護肌膚同時也洗去髒污。-->
              </li>
            </ul>
            <p class="font-weight-bold">Da vẫn được giữ ẩm sau khi rửa<!--洗後肌膚保持潤澤--></p>
            <ul>
              <li>
                4 loại thành phần axit nucleic giúp da ẩm, đàn hồi và ngậm nước hơn.
                <!--4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。-->
              </li>
              <li>
                Thành phần độc quyền "Kasparin" của FORDAYS được bổ sung, cũng như các thành phần bảo vệ da như chiết xuất lá samara, 
                axit hyaluronic Na và các thành phần dưỡng ẩm khác. Hiệu quả dưỡng ẩm của da vẫn được duy trì sau khi rửa.
                <!--添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。-->
              </li>
              <li>
                Thành phần dưỡng ẩm Lipidure (polyqu Parentium-51) ngăn ngừa độ ẩm của da bốc hơi và bảo vệ da.
                <!--保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。-->
              </li>
              <li>
                Đã thêm axit glycyrrhizic 2K, chiết xuất cây sơn chi và vitamin B12. Bảo vệ da và góp phần tăng cường sức khỏe làn da.
                <!--添加甘草酸2K和梔子花萃取物、維生素B12。保護肌膚，有助於肌膚的健康。-->
              </li>
            </ul>
            <p class="font-weight-bold">Một mùi thơm dễ chịu<!--讓人心情愉悅的香氣--></p>
            <ul>
              <li>
                Hương hoa cam quýt sảng khoái từ tinh dầu, hương thơm tinh tế giúp người dùng thư giãn hơn.
                <!--來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。-->
              </li>
            </ul>
            <p class="font-weight-bold">Nhẹ nhàng hơn trên da<!--對肌膚更溫柔的用心--></p>
            <ul>
              <li>
                Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc hương thơm.
                <!--不使用酒精、礦物油、色素和香料。-->
              </li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">Cách sử dụng<!--使用方法--></h3>
              <p>
                ◆Để làm sạch da mặt: Làm ướt xà phòng, xoa thành bọt, rửa mặt và rửa sạch bằng nước ấm.
                <!--◆洗顏用：將洗顏皂沾濕，搓揉出泡泡後洗臉，用溫水洗淨。-->
              </p>
              <p class="mb-0">
                ◆Đối với mặt nạ bong bóng: Dùng lưới tạo bọt để tạo bọt và thu một lượng lớn bong bóng vào lòng bàn tay, sau đó để bọt trên 
                mặt khoảng 30 giây đến 1 phút, sau đó rửa sạch lại bằng nước ấm. Nhẹ nhàng ấn bọt để làm sạch sâu hơn bụi bẩn trong lỗ chân lông hoặc đường da.
                <!--◆泡泡面膜用：用起泡網搓揉起泡並將大量的泡泡集中在掌心，然後將泡泡停置臉上約30秒到1分鐘，再用溫水充分洗淨。輕輕按壓泡泡，還可更進一步洗淨毛孔內或皮膚紋路的髒污。-->
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 7 夢莎逆時雙效洗顏皂Ⅱ end -->
      <!-- 8 夢莎逆時雙效賦活露Ⅱ -->
      <article
        id="product8Detail"
        v-if="$route.params.pid == 8"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活露Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Da có cảm giác ngậm nước<!--肌膚充滿水潤感-->
                   <br />
                  Dưỡng ẩm + nhập khẩu<!--保濕+導入-->
                </h2>
                <p>
                  Nó có "chức năng dưỡng ẩm" giúp giữ ẩm cho da và "chức năng giới thiệu" cho phép các thành phần trong huyết thanh làm đẹp được da dễ dàng 
                  hấp thụ hơn. Nhanh chóng thẩm thấu vào da, để lại làn da tràn đầy độ ẩm. Bổ sung các thành phần dưỡng ẩm khác biệt theo thời gian để giữ 
                  ẩm cho làn da của bạn trong thời gian dài.
                  <!--具有能讓肌膚保濕的「保濕機能」和讓美容液成分更容易被肌膚吸收的「導入機能」。快速滲透肌膚內，讓肌膚充滿水潤感。添加時間差保濕成分，即使長時間也能保持水潤。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>120ml</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">Giúp da ngậm nước và dưỡng ẩm<!--賦予肌膚水嫩潤澤--></p>
            <ul>
              <li>
                4 loại thành phần axit nucleic giúp da mềm mại, ẩm mượt, đàn hồi hơn và đầy nước.
                <!--4種核酸成分賦予肌膚水嫩潤澤更潤澤，更有彈性、充滿水感。-->
              </li>
              <li>
                Thành phần độc quyền "Kasparin" của FORDAYS được bổ sung, cũng như các thành phần bảo vệ da như chiết xuất lá samara, 
                axit hyaluronic Na và các thành phần dưỡng ẩm khác. Hiệu quả dưỡng ẩm của da vẫn được duy trì sau khi rửa.
                <!--添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。-->
              </li>
              <li>
                Thành phần dưỡng ẩm Lipidure (polyqu Parentium-51) ngăn ngừa độ ẩm của da bốc hơi và bảo vệ da.
                <!--保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。-->
              </li>
              <li>
                Chiết xuất hoa cúc, phân hủy mận châu Âu, dẫn xuất vitamin C, v.v., làm cho kết cấu da mịn hơn và trong suốt hơn.
                <!--雛菊花萃取物，歐洲李分解物，維他命C 誘導體等，使肌膚紋理細緻，更具透明感。-->
              </li>
              <li>
                Thành phần Glycyrrhizic acid 2K bảo vệ da và góp phần tăng cường sức khỏe làn da.
                <!--甘草酸2K成分，保護肌膚，有助於肌膚的健康。-->
              </li>
            </ul>
            <p class="font-weight-bold">Giữ làn da ngậm nước và dưỡng ẩm ở khắp mọi nơi<!--肌膚各處皆能保持水嫩潤澤--></p>
            <ul>
              <li>
                Dựa trên công nghệ đặc biệt "xử lý phân tán áp suất cao", các phân tử của từng thành phần được thêm vào sẽ được phân tán mịn và khả 
                năng thẩm thấu được tăng lên, cho phép da thẩm thấu nhanh chóng và giữ mọi thứ ẩm mượt và dẻo dai.
                <!--根據「高壓分散加工」的特殊技術，由於各個添加成分的分子細微分散、提高浸透力，使肌膚能快速滲透，各處皆保持水嫩潤澤。-->
              </li>
              <li>
                Các thành phần trong huyết thanh làm đẹp được hấp thụ vào da thông qua “chức năng giới thiệu” của “công nghệ vi nhũ hóa” hình thành các 
                viên nang siêu nhỏ. Nó thẩm thấu như thể được hấp thụ, giúp da ngậm nước và mềm mại, giữ cho da ở trạng thái mà các thành phần của serum 
                làm đẹp có thể dễ dàng hấp thụ.
                <!--透過將美容液成分形成超細微膠囊「微乳化技術」的「導入機能」使美容液成分吸收至肌膚。如被吸附般滲透、使肌膚水潤柔軟，維持肌膚容易吸收美容液成分的狀態。-->
              </li>
            </ul>
            <p class="font-weight-bold">Hãy để cảm giác hydrat hóa lan tỏa tới mọi ngóc ngách của làn da<!--讓水潤感傳達到肌膚的每一個角落--></p>
            <ul>
              <li>
                Thông qua công nghệ đặc biệt "xử lý phân tán áp suất cao", từng phân tử của các thành phần được thêm vào được phân tán cẩn thận, 
                tăng khả năng thẩm thấu và giúp da dễ hấp thụ hơn, giúp truyền hiệu quả dưỡng ẩm đến mọi ngóc ngách của da.
                <!--藉由「高壓分散加工」的特殊技術，將添加成分的各個分子細緻的分散，提高滲透度，讓肌膚更容易吸收，有助於讓潤澤效果傳達至肌膚每一個角落。-->
              </li>
              <li>
                "Chức năng giới thiệu" bắt nguồn từ "công nghệ vi phân tử" chuyển đổi các thành phần của tinh chất làm đẹp thành viên nang siêu mịn có 
                thể đưa các thành phần của tinh chất làm đẹp vào da, có tác dụng hấp thụ tốt hơn và có thể thẩm thấu vào da tốt hơn, làm cho Da mềm mại 
                hơn và làm cho tinh chất làm đẹp hoạt động hiệu quả hơn.
                <!--將美容液成分化為超微細膠囊的「微分子技術」而生的「導入機能」，將美容液成分導入肌膚，吸收效果更好，更能滲透肌膚，使肌膚更加柔嫩，更能使美容液成分發揮效果。-->
              </li>
            </ul>
            <p class="font-weight-bold">Một mùi thơm dễ chịu<!--讓人心情愉悅的香氣--></p>
            <ul>
              <li>
                Hương hoa cam quýt sảng khoái từ tinh dầu, hương thơm tinh tế giúp người dùng thư giãn hơn.
                <!--來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。-->
              </li>
            </ul>
            <p class="font-weight-bold">Nhẹ nhàng hơn trên da<!--對肌膚更溫柔的用心--></p>
            <ul>
              <li>
                Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc hương thơm.
                <!--不使用酒精、礦物油、色素和香料。-->
              </li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">Cách sử dụng<!--使用方法--></h3>
              <p class="mb-0">
                Lấy một lượng thích hợp vào lòng bàn tay, thoa đều toàn bộ khuôn mặt bằng lòng bàn tay, thoa nhẹ nhàng và thẩm thấu vào da.
                <!--取適量在掌心，用兩手手掌包覆全臉，輕輕延展推開，滲透至肌膚。-->
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 8 夢莎逆時雙效賦活露Ⅱ end -->
      <!-- 9 夢莎逆時雙效賦活霜Ⅱ -->
      <article
        id="product9Detail"
        v-if="$route.params.pid == 9"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活霜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">Giữ ẩm trong thời gian dài<!--長時間保持潤澤--> <br />Dưỡng ẩm + nhập khẩu<!--保濕+導入--></h2>
                <p>
                  Thêm 4 loại thành phần axit nucleic. Nó có "chức năng dưỡng ẩm" giúp dưỡng ẩm cho da và "chức năng giới thiệu" giúp da hấp thụ các thành 
                  phần serum làm đẹp dễ dàng hơn. Thông qua công nghệ nhũ hóa mới, các hạt mịn chứa thành phần dưỡng ẩm và thành phần serum làm đẹp có thể 
                  dễ dàng thẩm thấu vào da hơn, cho phép bạn trải nghiệm hiệu quả dưỡng ẩm cao. Chất kem đậm đà, mịn màng khi chạm vào, cung cấp một lớp 
                  bảo vệ dưỡng ẩm cho da. Bổ sung các thành phần yếu tố giữ ẩm lâu dài để duy trì độ ẩm trong thời gian dài.
                  <!--添加4種核酸成分。擁有肌膚水潤的「保濕機能」及讓肌膚更容易吸收美容液成分的「導入機能」。透過新乳化技術，讓含有保濕成分和美容液成分的細微粒子更容易滲透至肌膚，感受高度保濕的效果。豐潤的乳霜，滑順的觸感，為肌膚上一層水潤的保護。添加長效保濕因子成分，能長時間保持潤澤。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>30g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Đặc trưng<!--特點--></h2>
            <p class="font-weight-bold">Các hạt mới được tích hợp và thâm nhập nhiều hơn<!--更加融合滲透的新粒子--></p>
            <ul>
              <li>
                Áp dụng công nghệ nhũ hóa mới có khả năng cắt cao, độ phân tán đồng đều tuyệt vời và có thể tạo ra các hạt nhũ hóa mịn hơn. 
                Các hạt mịn có thể thẩm thấu các thành phần dưỡng ẩm và thành phần serum làm đẹp vào da. Bởi vì các hạt nhỏ có thể thẩm thấu 
                nhanh hơn các thành phần dưỡng ẩm và thành phần serum làm đẹp vào da (tầng sừng), giúp cải thiện cảm giác dưỡng ẩm và làm cho kem 
                phục hồi mềm hơn, dễ tán hơn và có cảm giác dễ chịu hơn.
                <!--採用剪斷能力高，具有優異均勻分散性，並可以製造出更細微的乳化粒子的新乳化技術。細小的粒子更能將保濕成分與美容液成分滲透至肌膚內。由於微小的粒子更能迅速將保濕成分與美容液成分滲透至肌膚（角質層），提高保濕感，也讓賦活霜更柔潤，更加容易延展，觸感也更佳。-->
              </li>
              <li>
                "Công nghệ vi phân tử" gói gọn các thành phần serum làm đẹp thành những viên nang siêu mịn cho phép các thành phần serum làm đẹp 
                được da dễ dàng hấp thụ hơn thông qua "chức năng giới thiệu" và thẩm thấu vào da, giúp da mềm mại hơn và duy trì tình trạng của da .
                <!--將美容液成分以超微細膠囊化的「微分子技術」，透過「導入機能」讓美容液成分更容易被肌膚所吸收，滲透肌膚，使肌膚更加柔軟，維持肌膚狀態。-->
              </li>
            </ul>
            <p class="font-weight-bold">Giúp da ngậm nước và dưỡng ẩm<!--賦予肌膚水嫩潤澤--></p>
            <ul>
              <li>
                "Nhũ hóa tinh thể lỏng" được phát triển dựa trên cấu trúc dưỡng ẩm trong lớp sừng của da, một dạng nhũ hóa "cấu trúc lamella" 
                với đặc tính dưỡng ẩm cực cao, cho phép kem phục hồi lan tỏa nhẹ nhàng hơn trên da, dưỡng ẩm và nhẹ nhàng. che phủ da.
                <!--參考肌膚角質層內的保濕結構，具有極高保濕性能的乳化型態「液晶構造(lamella structure)」，以此開發的「液晶乳化」，能讓賦活霜在肌膚上更加柔潤地延展，水潤溫柔地包覆肌膚。-->
              </li>
              <li>
                4 loại thành phần axit nucleic giúp da ẩm, đàn hồi và đầy nước.
                <!--4種核酸成分賦予肌膚水嫩潤澤，更有彈性、充滿水感。-->
              </li>
              <li>
                Thành phần độc quyền "Kasparin" của FORDAYS được bổ sung, cũng như các thành phần bảo vệ da như chiết xuất lá samara, 
                axit hyaluronic Na và các thành phần dưỡng ẩm khác. Hiệu quả dưỡng ẩm của da vẫn được duy trì sau khi rửa.
                <!--添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。-->
              </li>
              <li>
                Được bổ sung yếu tố dưỡng ẩm lâu dài "Biosacarit Gum-1" có độ dưỡng ẩm tăng theo thời gian, giúp da luôn được dưỡng ẩm.
                <!--添加保濕程度會隨著時間增加的長效保濕因子「生物糖膠-1(Biosaccharide Gum-1)」，讓肌膚持續維持水潤。-->
              </li>
              <li>
                Thành phần dưỡng ẩm Lipidure (polyqu Parentium-51) ngăn ngừa độ ẩm của da bốc hơi và bảo vệ da.
                <!--保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。-->
              </li>
              <li>
                Chiết xuất hoa cúc, phân hủy mận châu Âu, dẫn xuất vitamin C, v.v., làm cho kết cấu da mịn hơn và trong suốt hơn.
                <!--雛菊花萃取物，歐洲李分解物，維他命C 誘導體等，使肌膚紋理細緻，更具透明感。-->
              </li>
              <li>
                Thành phần Glycyrrhizic acid 2K bảo vệ da và góp phần tăng cường sức khỏe làn da.
                <!--甘草酸 2K成分，保護肌膚，也有助於肌膚的健康。-->
              </li>
            </ul>
            <p class="font-weight-bold">Một mùi thơm dễ chịu<!--讓人心情愉悅的香氣--></p>
            <ul>
              <li>
                Hương hoa cam quýt sảng khoái từ tinh dầu, hương thơm tinh tế giúp người dùng thư giãn hơn.
                <!--來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。-->
              </li>
            </ul>
            <p class="font-weight-bold">Nhẹ nhàng hơn trên da<!--對肌膚更溫柔的用心--></p>
            <ul>
              <li>Không sử dụng cồn, dầu khoáng, chất tạo màu hoặc hương thơm.<!--不使用酒精、礦物油、色素和香料。--></li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">Cách sử dụng<!--使用方法--></h3>
              <p class="mb-0">
                Lấy một lượng thích hợp vào lòng bàn tay và thoa đều từ giữa mặt ra ngoài,
                <!--取用適量在掌心，從臉部中心往外塗抹均勻，--> 
                <br />
                Che mặt bằng bàn tay hơi ấm và ấn nhẹ.
                <!--以微熱手溫包覆並輕輕按壓臉部。-->
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 9 夢莎逆時雙效賦活霜Ⅱ end -->
      <!-- 10 夢莎逆時雙效賦活面膜Ⅱ -->
      <article
        id="product10Detail"
        v-if="$route.params.pid == 10"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活面膜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  Loại bỏ bụi bẩn và tạo cảm giác mịn màng, trong suốt
                  <!--去除髒汙、擁有光滑透明感-->
                  <br />
                  Massage + đắp mặt nạ
                  <!--按摩+面膜-->
                </h2>
                <p>
                  Mặt nạ làm sạch chứa 4 loại thành phần axit nucleic.
                  <!--添加4種核酸成分洗淨用面膜。-->
                  <br />
                  Mặt nạ này sử dụng thành phần axit trái cây để làm mềm lớp sừng với tác dụng massage và hấp phụ.
                  <!--使用果酸成分軟化角質層的按摩效果及吸附效果的面膜。-->
                  <br />
                  Loại bỏ hiệu quả bã nhờn bị oxy hóa, tế bào da chết, lỗ chân lông bẩn, v.v. Làm cho làn da mịn màng và trong suốt. 
                  Viên nang chứa tinh chất cá thủy phân giúp dưỡng ẩm.
                  <!--有效去除氧化的皮脂、老廢角質、毛孔髒污等。使肌膚光滑呈現透明感。含有水解魚精的膠囊賦予保濕。-->
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">Khối lượng nội dung<!--內容量--></td>
                    <td>85g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Đặc trưng<!--特點--></h2>
            <p class="font-weight-bold">Loại bỏ hoàn toàn tạp chất trên da<!--徹底清除肌膚髒污--></p>
            <ul>
              <li>
                Bổ sung enzyme phân hủy bùn và protein tự nhiên có thể loại bỏ hiệu quả bã nhờn bị oxy hóa, tế bào da chết, lỗ chân lông bẩn, v.v.
                <!--添加天然泥與蛋白質分解酵素，能確實去除氧化的皮脂、老廢角質、毛孔髒污等。-->
              </li>
              <li>
                Có hai cách để sử dụng sản phẩm này. Nên mát-xa cho những người lo lắng về làn da xỉn màu và xỉn màu, đồng thời nên đắp mặt nạ cho những người lo ngại về lỗ chân lông to và da khô.
                <!--針對這款商品可以有兩種使用方法。針對肌膚的硬皮、暗沉感到在意的人推薦使用按摩的方式，以及對於毛孔粗大、乾燥肌膚在意的人推薦使用面膜來做保養。-->
              </li>
              <li>
                Rửa sạch thật sạch bụi bẩn dễ bám trên da do bảo dưỡng hàng ngày, sau đó điều chỉnh tình trạng da để kem dưỡng và serum làm đẹp được da hấp thụ nhanh chóng.
                <!--徹底洗淨容易因為每日的修護而殘留於肌膚的髒污，接著調整肌膚狀態至化妝水及美容液能快速被肌膚吸收。-->
              </li>
            </ul>
            <p class="font-weight-bold">Da vẫn được giữ ẩm sau khi làm sạch<!--肌膚潔淨後仍保有水潤感--></p>
            <ul>
              <li>
                Thêm 4 loại thành phần axit nucleic giúp da ẩm, đàn hồi và dẻo dai.
                <!--添加4種核酸成分使肌膚保濕滋潤、有彈性及水嫩。-->
              </li>
              <li>
                Viên nang lỏng chứa chiết xuất cá thủy phân lan rộng trên da khi sử dụng, cho phép các thành phần làm đẹp da thẩm thấu vào da và mang lại cảm giác dưỡng ẩm.
                <!--含有水解魚精萃取物的液體膠囊，使用時會在肌膚上蔓延開來使美肌成分滲透至肌膚賦予水潤感。-->
              </li>
              <li>
                Chứa các thành phần dưỡng ẩm như "Kasparin", thành phần độc quyền của Fudizhi, thành phần bảo vệ da chiết xuất lá Samara và natri hyaluronate. Nó có thể giữ cho làn da mềm mại và dẻo dai ngay cả sau khi làm sạch.
                <!--添加富地滋獨家成分「Kasparin」、肌膚保護成分翅果鐵刀木葉萃取物、透明質酸鈉等的保濕成分。清洗後也能保有肌膚的水嫩。-->
              </li>
              <li>
                Thêm chiết xuất hoa cúc, lê châu Âu thủy phân và các dẫn xuất vitamin C có thể định hình lại kết cấu da và mang lại làn da trong trẻo.
                <!--添加雛菊萃取物、水解歐洲梨、維他命C衍生物能重整肌膚紋理，實現透明肌。-->
              </li>
              <li>
                Dipotassium glycyrrhizinate bảo vệ da và làm cho da khỏe mạnh hơn.
                <!--甘草酸二鉀保護肌膚的同時，使肌膚更加健康。-->
              </li>
            </ul>
            <p class="font-weight-bold">Hương thơm thư giãn dễ chịu<!--愉悅放鬆的香氣--></p>
            <ul>
              <li>
                Hương thơm hoa cam quýt sảng khoái có nguồn gốc từ tinh dầu bao phủ làn da với hương thơm tinh tế, tạo cảm giác thư giãn.
                <!--來自精油的清爽柑橘花系香調，微微的香味包覆肌膚，感到放鬆。-->
              </li>
            </ul>
            <p class="font-weight-bold">Kết cấu thân thiện với da, thoải mái khi sử dụng<!--質地親膚，使用舒適--></p>
            <ul>
              <li>
                Không sử dụng cồn (etanol), dầu khoáng, chất tạo màu hoặc hương thơm. Sử dụng công thức nhẹ nhàng cho da.
                <!--不使用酒精(乙醇)、礦物油、色素、香料。使用對肌膚無負擔的配方。-->
              </li>
            </ul>
          </div>
        </section>
      </article>
      <!-- 10 夢莎逆時雙效賦活面膜Ⅱ end -->
      <!-- 11 新夢莎ED膠原蛋白飲EX -->
      <article
        id="product10Detail"
        v-if="$route.params.pid == 11"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/IMG_058-thumb-510x363-1106_2023.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">Sức khỏe và vẻ đẹp bên trong<!--內在健康美肌力--></h2>
                <p class="pr-3">
                  Chứa chiết xuất dứa mới được nâng cấp, collagen tripeptide, vitamin C, khoáng chất và chiết xuất vỏ móng mèo mới được bổ sung và các 
                  thành phần khác trong sự kết hợp cân bằng để duy trì sức khỏe và sắc đẹp mỗi ngày.
                  <!--含有全新升級的鳳梨抽出物、膠原三肽、維生素C、礦物質，並新添加貓爪藤樹皮抽出物等成分均衡搭配，維持健康美麗的每一天。-->
                </p>
              </div>
            </div>
            <div class="col-md-12">
              <table class="light-table mt-4 mb-4">
                <tr>
                  <th width="35%">Tên sản phẩm<!--產品名稱--></th>
                  <td class="font-weight-bold">
                    New Mengsha ED Collagen Drink EX (nước uống giải khát)
                    <!--新夢莎ED膠原蛋白飲EX (清涼飲料水)-->
                  </td>
                </tr>
                <tr>
                  <th>Giá thành viên (giá bán thống nhất)<!--會員價格(統一售價)--></th>
                  <td>NT. 2,250 nhân dân tệ/chai<!--NT. 2,250元/瓶--></td>
                </tr>
                <tr>
                  <th>Khối lượng nội dung<!--內容量--></th>
                  <td>500ml (25ml × 20 phần ăn)<!--500毫升 (25毫升×20份)--></td>
                </tr>
                <tr>
                  <th>Lưu phương pháp<!--保存方法--></th>
                  <td>
                    Hãy bảo quản sản phẩm ở nơi thoáng mát, tránh ánh nắng trực tiếp, nhiệt độ và độ ẩm cao. Hãy uống xong càng sớm càng tốt sau khi mở.
                    <!--產品請存放於陰涼處，避免陽光直射、高溫多溼處。開封後請盡早飲用完畢。-->
                  </td>
                </tr>
                <tr>
                  <th>Nội dung thành phần<!--成分內容物--></th>
                  <td>
                    Đường, mật ong, collagen cá [collagen (có nguồn gốc từ da cá), gelatin (có nguồn gốc từ da cá)], chiết xuất dứa, gia vị, 
                    axit ascorbic (vitamin C), chất làm đặc [pectin (chanh, chanh), kẹo cao su đường ngô], hương liệu (axit citric, natri citrate), 
                    chiết xuất vỏ cây móng mèo (vỏ móng mèo, maltodextrin), màu caramel thông thường, men kẽm, chất làm ngọt (sucralose), men Selenium, 
                    pyridoxine hydrochloride (vitamin B6), riboflavin (vitamin B2), thiamine nitrat (vitamin B1), chiết xuất tinh hoàn cá hồi, 
                    chất nhũ hóa (axit béo glyceride)
                    <!--砂糖、蜂蜜、魚膠原蛋白【膠原蛋白(魚皮由來)、明膠(魚皮由來)】、鳳梨抽出物、香料、抗壞血酸(維生素C)、粘稠劑【果膠(檸檬、萊姆)、玉米糖膠】、調味劑(檸檬酸、檸檬酸鈉)、貓爪藤樹皮抽出物(貓爪藤樹皮、麥芽糊精)、普通焦糖色素、鋅酵母、甜味劑(蔗糖素)、硒酵母、鹽酸吡哆辛(維生素B6)、核黃素(維生素B2)、硝酸硫胺明(維生素B1)、鮭魚精巢抽出物、乳化劑(脂肪酸甘油酯)-->
                  </td>
                </tr>
                <tr>
                  <th>Nhãn dinh dưỡng (trên 100ml)<!--營養標示(每100ml)--></th>
                  <td>
                    Calo: 54 kcal, protein: 0,8 g, chất béo: 0 g, carbohydrate: 12,8 g, đường: 10 g, natri: 15,4 mg
                    <!--熱量：54大卡、蛋白質：0.8公克、脂肪：0公克、碳水化合物：12.8公克、糖：10公克、鈉：15.4毫克-->
                  </td>
                </tr>
                <tr>
                  <th>Cách uống<!--飲用方式--></th>
                  <td>
                    Giới hạn 1 khẩu phần mỗi ngày. Làm lạnh và lắc nhẹ trước khi uống. Hãy uống càng sớm càng tốt sau khi mở.
                    <!--1天限1份。冰鎮並輕搖均勻後飲用。開封後請儘速飲用完畢。-->
                  </td>
                </tr>
                <tr>
                  <th>Ghi nhãn chất gây dị ứng<!--過敏原標示--></th>
                  <td>
                    ● Sản phẩm này có chứa cá và các sản phẩm từ cá. 
                    ● Phụ nữ có thai, phụ nữ đang cho con bú, trẻ sơ sinh và trẻ nhỏ dưới ba tuổi không nên dùng. 
                    ● Nếu bạn đang sử dụng thuốc chống đông máu, hãy hỏi bác sĩ trước.
                    <!--●本產品含有魚類及其製品 ●孕婦、授乳婦女及三歲以下嬰幼兒不宜食用 ●使用抗凝血劑者，食用前須先諮詢醫生-->
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </section>
      </article>
      <!-- 11 新夢莎ED膠原蛋白飲EX end -->
      <div v-if="isMousa">
        <MousaProductSection />
      </div>
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/productHeaderNav";
import MousaProductSection from "@/components/public/MousaProductSection";
export default {
  name: "ProductDetailScreen",
  components: {
    PublicLayout,
    HeaderNav,
    MousaProductSection,
  },
  computed: {
    showProductTitle() {
      if (this.$route.params.pid in this.productNameList) {
        return this.productNameList[this.$route.params.pid];
      }
      return "";
    },
    isMousa() {
      const id = this.$route.params.pid;
      const name = this.productNameList[id];
      if (name.indexOf("夢莎逆時") >= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      productNameList: {
        1: "Collagen Fudizhi DN",
        2: "Túi xách tay Fortune Zi LOHAS",
        3: "Mới‧Nước uống Collagen Mengsha ED",
        4: "LU tia Tinh chất làm đẹp hiệu suất cao",
        5: "Sữa rửa mặt tác động kép đảo ngược thời gian Mengsha Ⅱ",
        6: "Kem rửa mặt tác dụng gấp đôi thời gian đảo ngược Mengsha Ⅱ",
        7: "Xà phòng rửa mặt tác động kép đảo ngược thời gian Mengsha Ⅱ",
        8: "Kem dưỡng phục hồi tái tạo hiệu ứng kép Mengsha Reverse Time II",
        9: "Kem làm sạch và phục hồi tác động kép đảo ngược thời gian của Mengsha Ⅱ",
        10: "Mặt nạ hồi sinh tác dụng gấp đôi thời gian của Mengsha Ⅱ",
        11: "Nước uống Collagen Mengsha ED mới EX",
      },
    };
  },
};
</script>
